// uiarc: textarea (https://uiarc.dev/r/textarea.json) alan gövdesi; `Input` ile aynı dil. uiarc kaynağı odakta
// `0 0 0 3px var(--focus-ring)` çizer; bu projede `--focus-ring` saydamdır (index.css, Faz 1), bu yüzden
// yalnız kenarlık rengi değişir, `Input` ile birebir aynı.
import * as React from 'react'
import { cn } from '@/lib/utils'

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-border-strong bg-surface text-foreground placeholder:text-text-muted rounded-control leading-body ease-standard min-h-27.5 w-full resize-y border p-3 text-sm transition-[border-color,background-color] duration-(--duration-fast) outline-none motion-reduce:transition-none',
        'not-disabled:not-aria-invalid:hover:border-foreground focus-visible:border-foreground aria-invalid:border-danger',
        'disabled:bg-surface-muted disabled:cursor-not-allowed disabled:opacity-60',
        className,
      )}
      {...props}
    />
  )
}

export { Textarea }
